<template>
  <div>
    <!-- Page Header -->
    <div class="row mb-4 align-items-center">
      <div class="col">
        <h4 class="review-domain--page-title">Review Domain</h4>
      </div>
      <!-- <div class="col-auto d-flex align-items-center" style="color: #4b4b4b; font-size: 14px;">
        Latest Update: {{ latestUpdate || '-' }}
        <i class="fal fa-info-circle ml-2" style="color: #4b4b4b;"></i>
      </div> -->
    </div>

    <!-- Stat Cards -->
    <div class="d-flex mb-4" style="gap: 16px;">
      <domain-summary-stats-card title="Total Domain Suspicious" :value="stats.totalSuspicious" icon-bg-color="#dcefff">
        <template #icon>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16.6667 14.6667L23.3333 21.3333L21.3333 23.3333L14.6667 16.6667V15.6133L14.3067 15.24C12.7388 16.5919 10.7369 17.3349 8.66667 17.3333C6.36812 17.3333 4.16372 16.4202 2.53841 14.7949C0.913092 13.1696 0 10.9652 0 8.66667C0 6.36812 0.913092 4.16372 2.53841 2.53841C4.16372 0.913092 6.36812 0 8.66667 0C10.9652 0 13.1696 0.913092 14.7949 2.53841C16.4202 4.16372 17.3333 6.36812 17.3333 8.66667C17.3333 10.8133 16.5467 12.7867 15.24 14.3067L15.6133 14.6667H16.6667ZM8.66667 2L7.93333 2.04C7.61333 2.73333 7.12 3.90667 6.76 5.33333H10.5733C10.2133 3.90667 9.72 2.73333 9.4 2.04C9.16 2 8.92 2 8.66667 2ZM14.44 5.33333C13.6474 3.94589 12.3774 2.8939 10.8667 2.37333C11.1867 3.08 11.6 4.10667 11.9067 5.33333H14.44ZM2.89333 5.33333H5.42667C5.73333 4.10667 6.14667 3.08 6.46667 2.37333C4.95595 2.8939 3.68597 3.94589 2.89333 5.33333ZM2 8.66667C2 9.33333 2.10667 10.04 2.30667 10.6667H5.16L5 8.66667L5.16 6.66667H2.30667C2.10667 7.29333 2 8 2 8.66667ZM15.0267 10.6667C15.2267 10.04 15.3333 9.33333 15.3333 8.66667C15.3333 8 15.2267 7.29333 15.0267 6.66667H12.1733C12.3852 7.99158 12.3852 9.34175 12.1733 10.6667H15.0267ZM6.49333 6.66667L6.33333 8.66667L6.49333 10.6667H10.84C11.0519 9.34175 11.0519 7.99158 10.84 6.66667H6.49333ZM8.66667 15.3333C8.90667 15.3333 9.14667 15.3333 9.37333 15.2933C9.70667 14.6 10.2133 13.4267 10.5733 12H6.76C7.12 13.4267 7.62667 14.6 7.96 15.2933L8.66667 15.3333ZM14.44 12H11.9067C11.6 13.2267 11.1867 14.2533 10.8667 14.96C12.3774 14.4394 13.6474 13.3874 14.44 12ZM2.89333 12C3.68597 13.3874 4.95595 14.4394 6.46667 14.96C6.14667 14.2533 5.73333 13.2267 5.42667 12H2.89333Z"
              fill="#267CE5" />
          </svg>
        </template>
      </domain-summary-stats-card>

      <domain-summary-stats-card title="Under Review" :value="stats.underReview" icon-bg-color="#FFF3CD">
        <template #icon>
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M25.9821 14.0859C25.7697 16.5559 24.8562 18.9138 23.3492 20.8822C21.8422 22.8507 19.8043 24.3478 17.4753 25.1974C15.1464 26.047 12.6232 26.2137 10.2027 25.678C7.78216 25.1423 5.56499 23.9265 3.81201 22.1735C2.05903 20.4205 0.84317 18.2034 0.307482 15.7828C-0.228207 13.3623 -0.0614411 10.8391 0.788159 8.51019C1.63776 6.18123 3.13485 4.14336 5.1033 2.63634C7.07174 1.12933 9.42965 0.215855 11.8996 0.00339743C12.0309 -0.00743662 12.1631 0.00770108 12.2886 0.0479464C12.4141 0.0881918 12.5304 0.152757 12.6309 0.237954C12.7314 0.323152 12.8142 0.427314 12.8744 0.544494C12.9347 0.661673 12.9713 0.789576 12.9821 0.920897C12.993 1.05222 12.9778 1.18439 12.9376 1.30986C12.8973 1.43533 12.8328 1.55165 12.7476 1.65217C12.6624 1.75269 12.5582 1.83544 12.441 1.89571C12.3238 1.95597 12.1959 1.99256 12.0646 2.0034C9.9741 2.18301 7.97838 2.95598 6.31226 4.23135C4.64614 5.50672 3.37894 7.23143 2.65978 9.20255C1.94061 11.1737 1.79939 13.3092 2.25273 15.3579C2.70607 17.4065 3.73511 19.2831 5.21877 20.7667C6.70244 22.2504 8.579 23.2794 10.6277 23.7328C12.6763 24.1861 14.8118 24.0449 16.783 23.3257C18.7541 22.6066 20.4788 21.3394 21.7542 19.6733C23.0295 18.0071 23.8025 16.0114 23.9821 13.9209C24.004 13.6557 24.1303 13.41 24.3333 13.238C24.5364 13.0659 24.7994 12.9815 25.0646 13.0034C25.3298 13.0253 25.5755 13.1516 25.7476 13.3546C25.9196 13.5576 26.004 13.8207 25.9821 14.0859ZM11.9821 6.0034V13.0034C11.9821 13.2686 12.0875 13.523 12.275 13.7105C12.4626 13.898 12.7169 14.0034 12.9821 14.0034H19.9821C20.2473 14.0034 20.5017 13.898 20.6892 13.7105C20.8768 13.523 20.9821 13.2686 20.9821 13.0034C20.9821 12.7382 20.8768 12.4838 20.6892 12.2963C20.5017 12.1088 20.2473 12.0034 19.9821 12.0034H13.9821V6.0034C13.9821 5.73818 13.8768 5.48383 13.6892 5.29629C13.5017 5.10875 13.2473 5.0034 12.9821 5.0034C12.7169 5.0034 12.4626 5.10875 12.275 5.29629C12.0875 5.48383 11.9821 5.73818 11.9821 6.0034ZM16.9821 3.0034C17.2788 3.0034 17.5688 2.91542 17.8155 2.7506C18.0621 2.58578 18.2544 2.35151 18.3679 2.07742C18.4815 1.80333 18.5112 1.50173 18.4533 1.21076C18.3954 0.919791 18.2526 0.652516 18.0428 0.442737C17.833 0.232959 17.5657 0.0900974 17.2748 0.0322196C16.9838 -0.0256582 16.6822 0.00404679 16.4081 0.117578C16.134 0.23111 15.8997 0.423368 15.7349 0.670042C15.5701 0.916716 15.4821 1.20673 15.4821 1.5034C15.4821 1.90122 15.6402 2.28275 15.9215 2.56406C16.2028 2.84536 16.5843 3.0034 16.9821 3.0034ZM21.4821 6.0034C21.7788 6.0034 22.0688 5.91542 22.3155 5.7506C22.5621 5.58578 22.7544 5.35151 22.8679 5.07742C22.9815 4.80333 23.0112 4.50173 22.9533 4.21076C22.8954 3.91979 22.7526 3.65252 22.5428 3.44274C22.333 3.23296 22.0657 3.0901 21.7748 3.03222C21.4838 2.97434 21.1822 3.00405 20.9081 3.11758C20.634 3.23111 20.3997 3.42337 20.2349 3.67004C20.0701 3.91672 19.9821 4.20673 19.9821 4.5034C19.9821 4.90122 20.1402 5.28275 20.4215 5.56406C20.7028 5.84536 21.0843 6.0034 21.4821 6.0034ZM24.4821 10.5034C24.7788 10.5034 25.0688 10.4154 25.3155 10.2506C25.5621 10.0858 25.7544 9.85151 25.8679 9.57742C25.9815 9.30333 26.0112 9.00173 25.9533 8.71076C25.8954 8.41979 25.7526 8.15252 25.5428 7.94274C25.333 7.73296 25.0657 7.5901 24.7748 7.53222C24.4838 7.47434 24.1822 7.50405 23.9081 7.61758C23.634 7.73111 23.3997 7.92337 23.2349 8.17004C23.0701 8.41672 22.9821 8.70673 22.9821 9.0034C22.9821 9.40122 23.1402 9.78275 23.4215 10.0641C23.7028 10.3454 24.0843 10.5034 24.4821 10.5034Z"
              fill="#EF6820" />
          </svg>
        </template>
      </domain-summary-stats-card>

      <domain-summary-stats-card title="Watchlisted" :value="stats.watchlisted" icon-bg-color="#FFE0E0">
        <template #icon>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19.7081 18.2931C19.801 18.386 19.8747 18.4963 19.9249 18.6177C19.9752 18.7391 20.0011 18.8692 20.0011 19.0006C20.0011 19.132 19.9752 19.2621 19.9249 19.3835C19.8747 19.5048 19.801 19.6151 19.7081 19.7081C19.6151 19.801 19.5048 19.8747 19.3835 19.9249C19.2621 19.9752 19.132 20.0011 19.0006 20.0011C18.8692 20.0011 18.7391 19.9752 18.6177 19.9249C18.4963 19.8747 18.386 19.801 18.2931 19.7081L10.0006 11.4143L1.70806 19.7081C1.52042 19.8957 1.26592 20.0011 1.00056 20.0011C0.735192 20.0011 0.480697 19.8957 0.293056 19.7081C0.105415 19.5204 5.23096e-09 19.2659 0 19.0006C-5.23096e-09 18.7352 0.105415 18.4807 0.293056 18.2931L8.58681 10.0006L0.293056 1.70806C0.105415 1.52042 0 1.26592 0 1.00056C0 0.735192 0.105415 0.480697 0.293056 0.293056C0.480697 0.105415 0.735192 0 1.00056 0C1.26592 0 1.52042 0.105415 1.70806 0.293056L10.0006 8.58681L18.2931 0.293056C18.4807 0.105415 18.7352 -5.23096e-09 19.0006 0C19.2659 5.23096e-09 19.5204 0.105415 19.7081 0.293056C19.8957 0.480697 20.0011 0.735192 20.0011 1.00056C20.0011 1.26592 19.8957 1.52042 19.7081 1.70806L11.4143 10.0006L19.7081 18.2931Z"
              fill="#EC1B30" />
          </svg>
        </template>
      </domain-summary-stats-card>
    </div>

    <!-- Suspicious Domain List Table -->
    <div class="rd-table-container">
      <!-- Table Header Row -->
      <div class="d-flex align-items-center justify-content-between mb-3">
        <span class="rd-table-title">Suspicious Domain List</span>
        <div class="d-flex align-items-center" style="gap: 10px;">
          <!-- Search -->
          <div class="rd-search">
            <input type="text" class="rd-search__input" placeholder="Search Domain" v-model="search"
              @input="onSearchChange" />
            <!-- <i class="far fa-search rd-search__icon"></i> -->
            <font-awesome-icon icon="search" class="rd-search__icon" />
          </div>
          <!-- Status Filter -->
          <select v-model="filterStatus" class="rd-filter-select" @change="onFilterChange">
            <option :value="null">All Status</option>
            <option value="under_review">Under Review</option>
            <option value="watchlisted">Watchlisted</option>
          </select>
        </div>
      </div>

      <!-- Loading -->
      <div v-if="tableLoading" class="text-center mt-3 mb-3">
        <h4>Loading...</h4>
      </div>

      <!-- Table -->
      <div v-else style="overflow-x: auto; overflow-y: hidden;">
        <table class="table scan-history-table" style="margin: 0;">
          <thead>
            <tr>
              <th>Domain</th>
              <th>Total Scan</th>
              <th>First Scan</th>
              <!-- <th>Location</th> -->
              <th>District</th>
              <th>Risk Score</th>
              <th>Domain Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in tableData" :key="`${currentPage}-${index}`">
              <td class="domain-cell">{{ row.domain_url || '-' }}</td>
              <td>{{ row.total_scan || '-' }}</td>
              <td>{{ row.first_scan || '-' }}</td>
              <!-- <td>{{ row.location || '-' }}</td> -->
              <td>{{ row.district || '-' }}</td>
              <td>
                <span class="top5-table__badge" :class="riskClass(row.risk_score)">{{ row.risk_score || '-' }}</span>
              </td>
              <td>
                <span class="top5-table__badge" :class="statusClass(row.domain_status)">
                  {{ formatDomainStatus(row.domain_status) }}
                </span>
              </td>
              <td class="actions-cell">
                <div class="top5-table__actions">
                  <button v-if="isWatchlistable(row.domain_status)" class="top5-table__btn top5-table__btn--watchlist"
                    @click="onWatchlist(row)">Watchlist</button>
                  <button class="top5-table__btn top5-table__btn--detail" @click="viewDetail(row)">Detail</button>
                </div>
              </td>
            </tr>
            <tr v-if="!tableLoading && tableData.length === 0">
              <td colspan="7" class="text-center">No data available</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="row mt-3" v-if="!tableLoading && (tableData.length > 0 || maxPage > 0)">
        <div class="col-12 d-flex align-items-center justify-content-between flex-wrap">
          <div class="d-flex align-items-center">
            <label style="margin-right: 8px; margin-bottom: 0; color: #cbcbcb; font-size: 14px;">View</label>
            <select v-model="limitPerPage" @change="onLimitChange" class="form-control form-control-sm"
              style="width: auto; display: inline-block; padding: 4px 8px;">
              <option :value="10">10</option>
              <option :value="25">25</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
            </select>
            <span class="items-per-page-text">items per page</span>
          </div>
          <div class="d-flex align-items-center flex-wrap">
            <p class="mt-2 mb-2" style="color: #cbcbcb; margin-right: 20px; margin-bottom: 0;">
              Showing {{ total === 0 ? 0 : (currentPage - 1) * limitPerPage + 1 }}-{{ total > currentPage * limitPerPage
                ? currentPage * limitPerPage : total }} of {{ total }} Items </p>
                <nav class="pagination-minimal">
                  <ul class="pagination" style="margin: 0; flex-wrap: wrap;">
                    <li class="page-item" :class="{ disabled: currentPage <= 1 }"
                      @click.stop.prevent="changePage('prev')">
                      <a class="page-link" href="javascript:void(0)">&lsaquo;</a>
                    </li>
                    <li class="page-item" :class="{ disabled: currentPage >= maxPage }"
                      @click.stop.prevent="changePage('next')">
                      <a class="page-link" href="javascript:void(0)">&rsaquo;</a>
                    </li>
                  </ul>
                </nav>
          </div>
        </div>
      </div>
    </div>

    <!-- Watchlist Confirmation Modal -->
    <b-modal v-model="watchlistModal.show" centered size="sm" hide-header hide-footer>
      <div class="watchlist-modal">
        <div class="watchlist-modal__icon">
          <img :src="require('@/assets/icons/domain-detection/watchlist-warning.svg')" width="109" height="109" />
        </div>
        <div class="watchlist-modal__body">
          <p class="watchlist-modal__title">Watchlist This Domain?</p>
          <p class="watchlist-modal__subtitle">This domain's status will be changed to Watchlisted for ongoing
            monitoring.
          </p>
        </div>
        <div class="watchlist-modal__footer">
          <button class="watchlist-modal__btn watchlist-modal__btn--cancel" @click="watchlistModalHide">Cancel</button>
          <button class="watchlist-modal__btn watchlist-modal__btn--confirm" :disabled="watchlistModal.loading"
            @click="watchlistConfirm">
            <span v-if="watchlistModal.loading">
              <b-spinner small></b-spinner>
            </span>
            <span v-else>Add to Watchlist</span>
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Watchlist Success Modal -->
    <b-modal v-model="successModal.show" centered size="sm" hide-header hide-footer>
      <div class="watchlist-modal">
        <div class="watchlist-modal__icon">
          <img :src="require('@/assets/icons/domain-detection/watchlist-success.svg')" width="134" height="134" />
        </div>
        <div class="watchlist-modal__body">
          <p class="watchlist-modal__title">Successfully Watchlisted Domain</p>
          <p class="watchlist-modal__subtitle">Domain successfully added to watchlist</p>
        </div>
        <div class="watchlist-modal__footer">
          <button class="watchlist-modal__btn watchlist-modal__btn--confirm"
            @click="successModal.show = false">OK</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import qs from 'qs'
import DomainSummaryStatsCard from './children/DomainSummaryStatsCard.vue'

export default {
  metaInfo: {
    title: 'Domain Detection - Review Domain',
  },
  components: {
    DomainSummaryStatsCard,
  },
  data() {
    return {
      stats: {
        totalSuspicious: 0,
        underReview: 0,
        watchlisted: 0,
      },
      latestUpdate: null,
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      maxPage: 1,
      total: 0,
      limitPerPage: 10,
      search: '',
      filterStatus: null,
      fetchDataTimer: null,
      watchlistModal: {
        show: false,
        item: null,
        loading: false,
      },
      successModal: {
        show: false,
      },
    }
  },
  mounted() {
    this.fetchStats()
    this.fetchTableData()
  },
  beforeDestroy() {
    if (this.fetchDataTimer) clearTimeout(this.fetchDataTimer)
  },
  methods: {
    formatDateOnly(val) {
      if (!val) return '-'
      const d = new Date(val)
      if (isNaN(d)) return val
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    },
    async fetchStats() {
      try {
        const resp = await this.$http.get('/api/domain-detection-review-domain/overview')
        const data = resp.data.data || {}
        this.stats.totalSuspicious = data.total_domain_suspicious || 0
        this.stats.underReview = data.under_review || 0
        this.stats.watchlisted = data.watchlisted || 0
        this.latestUpdate = data.latest_update ? this.formatDateOnly(data.latest_update) : null
      } catch (err) {
        this.errorPrint(err)
      }
    },
    async fetchTableData() {
      this.tableLoading = true
      try {
        // const now = new Date()
        // const y = now.getFullYear()
        // const m = String(now.getMonth() + 1).padStart(2, '0')
        // const lastDay = new Date(y, now.getMonth() + 1, 0).getDate()

        const params = {
          page: this.currentPage,
          limit: this.limitPerPage,
          // start_date: `${y}-${m}-01`,
          // end_date: `${y}-${m}-${lastDay}`,
          domain_status: this.filterStatus || '',
          search_domain: this.search || '',
        }

        const resp = await this.$http.get('/api/domain-detection-review-domain/table', {
          params,
        })
        const respData = resp.data.data || {}
        const pagination = respData.pagination || {}
        this.tableData = (respData.data || []).map(row => ({
          ...row,
          location: row.location,
          district: row.district,
        }))
        this.currentPage = Number.parseInt(pagination.page) || 1
        this.maxPage = Number.parseInt(pagination.total_page) || 1
        this.total = Number.parseInt(pagination.total_data) || 0
      } catch (err) {
        this.errorPrint(err)
        this.tableData = []
      } finally {
        this.tableLoading = false
      }
    },
    onWatchlist(row) {
      this.watchlistModal.item = row
      this.watchlistModal.show = true
    },
    watchlistModalHide() {
      this.watchlistModal.show = false
      this.watchlistModal.item = null
    },
    async watchlistConfirm() {
      this.watchlistModal.loading = true
      try {
        await this.$http.post('/api/domain-detection-review-domain/update-watchlist', {
          domain_id: this.watchlistModal.item.domain_id,
          watchlist: true,
        })
        this.watchlistModal.show = false
        this.watchlistModal.item = null
        this.successModal.show = true
        this.fetchStats()
        this.fetchTableData()
      } catch (err) {
        this.errorPrint(err)
      } finally {
        this.watchlistModal.loading = false
      }
    },
    viewDetail(row) {
      this.$router.push({ name: 'ReviewDomainDetail', params: { domain_id: row.domain_id } })
    },
    changePage(direction) {
      if (direction === 'prev' && this.currentPage > 1) {
        this.currentPage--
        this.fetchTableData()
      } else if (direction === 'next' && this.currentPage < this.maxPage) {
        this.currentPage++
        this.fetchTableData()
      }
    },
    onLimitChange() {
      this.currentPage = 1
      this.fetchTableData()
    },
    onSearchChange() {
      if (this.fetchDataTimer) clearTimeout(this.fetchDataTimer)
      this.fetchDataTimer = setTimeout(() => {
        this.currentPage = 1
        this.fetchTableData()
      }, 500)
    },
    onFilterChange() {
      this.currentPage = 1
      this.fetchTableData()
    },
    riskClass(score) {
      if (!score) return ''
      const s = score.toLowerCase()
      if (s === 'high') return 'top5-table__badge--high'
      if (s === 'medium') return 'top5-table__badge--medium'
      if (s === 'low') return 'top5-table__badge--low'
      return ''
    },
    statusClass(status) {
      if (!status) return ''
      const s = status.toLowerCase().replace(/ /g, '_')
      if (s === 'under_review') return 'top5-table__badge--under-review'
      if (s === 'watchlisted') return 'top5-table__badge--watchlisted'
      if (s === 'dismissed') return 'top5-table__badge--dismissed'
      return ''
    },
    isWatchlistable(status) {
      if (!status) return true
      const s = status.toLowerCase()
      return s !== 'watchlisted' && s !== 'dismissed'
    },
    formatDomainStatus(status) {
      if (!status) return '-'
      return status
    },
  },
}
</script>

<style scoped>
/* Page header */
.review-domain--page-title {
  font-size: 16px;
  font-weight: 700;
  color: #4b4b4b;
  margin: 0;
}

/* Table container */
.rd-table-container {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
}

/* Table section title */
.rd-table-title {
  font-size: 14px;
  font-weight: 600;
  color: #000;
}

/* Search input */
.rd-search {
  position: relative;
  width: 290px;
}

.rd-search__input {
  width: 100%;
  height: 28px;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  padding: 0 28px 0 10px;
  font-size: 12px;
  color: #4b4b4b;
  box-shadow: 0 0 1.5px rgba(0, 0, 0, 0.1);
  outline: none;
}

.rd-search__input::placeholder {
  color: #9d9d9d;
}

.rd-search__icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #9d9d9d;
  font-size: 10px;
  pointer-events: none;
}

/* Status filter dropdown */
.rd-filter-select {
  height: 28px;
  width: 148px;
  padding: 0 8px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #4b4b4b;
  background-color: #fff;
  box-shadow: 0 0 1.5px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  outline: none;
}

/* Table typography */
.scan-history-table thead th {
  font-weight: 600 !important;
  font-size: 12px !important;
  color: #9d9d9d !important;
  border-top: 1px solid #e6e6e6;
  white-space: nowrap;
  padding: 10px 8px;
}

.scan-history-table tbody td {
  font-weight: 400 !important;
  font-size: 12px !important;
  color: #393939 !important;
  border-bottom: 1px solid #e6e6e6 !important;
  border-top: none !important;
  vertical-align: middle;
  padding: 10px 8px;
}

.scan-history-table tbody td.domain-cell {
  word-break: break-all;
  overflow-wrap: anywhere;
  max-width: 320px;
  min-width: 180px;
}

.scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}

/* Badge base */
.top5-table__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.06px;
  white-space: nowrap;
}

/* Risk modifiers */
.top5-table__badge--high {
  background: #D92D20;
  color: #fff;
}

.top5-table__badge--medium {
  background: #FDB022;
  color: #fff;
}

.top5-table__badge--low {
  background: #12B76A;
  color: #fff;
}

/* Status modifiers */
.top5-table__badge--under-review {
  background: #FFF9F5;
  color: #ec911b;
}

.top5-table__badge--watchlisted {
  background: #FFFBFA;
  color: #F04438;
}

.top5-table__badge--dismissed {
  background: #FAFAFA;
  color: #4B4B4B;
}

/* Action buttons */
.top5-table__actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.top5-table__btn {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  box-shadow: 0 0 1.5px rgba(0, 0, 0, 0.1);
}

.top5-table__btn--watchlist {
  background: #267CE5;
  color: #fff;
}

.top5-table__btn--detail {
  background: #fff;
  color: #4b4b4b;
}

.actions-cell {
  white-space: nowrap;
}

.items-per-page-text {
  margin-left: 8px;
  color: #cbcbcb;
  font-size: 14px;
}

/* Watchlist / Success modals */
.watchlist-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 8px 16px 16px;
}

.watchlist-modal__icon {
  margin-bottom: 4px;
}

.watchlist-modal__body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: center;
  padding: 0 8px;
}

.watchlist-modal__title {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  margin: 0;
}

.watchlist-modal__subtitle {
  font-size: 14px;
  color: rgba(165, 165, 165, 0.87);
  margin: 0;
}

.watchlist-modal__footer {
  display: flex;
  gap: 16px;
  width: 100%;
  padding: 10px 0 0;
}

.watchlist-modal__btn {
  flex: 1;
  padding: 10px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
}

.watchlist-modal__btn--cancel {
  background: #fff;
  border: 1px solid #267ce5;
  color: #267ce5;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
}

.watchlist-modal__btn--confirm {
  background: #267ce5;
  border: 1px solid #e8e8e8;
  color: #fff;
  box-shadow: 0 0 1.5px rgba(0, 0, 0, 0.1);
}

.watchlist-modal__btn--confirm:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
